import projectKnowledgeActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  pendingDeleteGeneSet: null,
  geneSetCache: [],
};

const reducer = createReducer(INITIAL_STATE, {
  [projectKnowledgeActionTypes.PROJECT_KNOWLEDGE_SET_GENESET_CACHE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      geneSetCache: action.geneSetCache,
    };
  },
  [projectKnowledgeActionTypes.PROJECT_KNOWLEDGE_REMOVE_GENESET_FROM_CACHE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      geneSetCache: state.geneSetCache.filter(
        (geneSet: any) => geneSet.id !== action.geneSetId,
      ),
    };
  },
  [projectKnowledgeActionTypes.PROJECT_KNOWLEDGE_UPDATE_GENESET_IN_CACHE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      geneSetCache: state.geneSetCache.map((geneSet: any) =>
        geneSet.id === action.geneSet.id ? action.geneSet : geneSet,
      ),
    };
  },
  [projectKnowledgeActionTypes.PROJECT_KNOWLEDGE_ADD_GENESET_TO_CACHE]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      geneSetCache: [...state.geneSetCache, action.geneSet],
    };
  },
  [projectKnowledgeActionTypes.PROJECT_KNOWLEDGE_SET_PENDING_DELETE_GENESET]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      pendingDeleteGeneSet: action.geneSetId,
    };
  },
});

export default reducer;
